import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { ComingSoon } from "@/components/coming-soon";
import { DataTableSearchSchema } from "@/components/ui/data-table-generic";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/episodes/$episodeId/jingles")({
	component: Page,
	validateSearch: (search) => DataTableSearchSchema.parse(search),
	params: z.object({
		episodeId: z.coerce.number(),
	}),
	async loader({ context, params, preload }) {
		if (!preload) {
			return;
		}

		context.queryClient.prefetchQuery(
			orpc.episodes.show.queryOptions({
				input: {
					episodeId: params.episodeId,
				},
			}),
		);
		// context.queryClient.prefetchQuery(
		// 	orpc.channels.listJingles.queryOptions({
		// 		input: {
		// 			channelId: params.channelId,
		// 		},
		// 	}),
		// );
	},
});

function Page() {
	return <ComingSoon />;
	// const params = Route.useParams();
	// const search = Route.useSearch();
	// const navigate = Route.useNavigate();

	// const { data, isFetching, refetch } = useSuspenseQuery(
	// 	orpc.channels.listJingles.queryOptions({
	// 		input: {
	// 			channelId: params.channelId,
	// 		},
	// 	}),
	// );

	// const [globalFilter, setGlobalFilter] = useState(search.q ?? "");

	// const handleNavigate = useCallback(
	// 	(params: DataTableSearchParams) => {
	// 		navigate({
	// 			replace: true,
	// 			search: (prev) => ({
	// 				...prev,
	// 				...params,
	// 			}),
	// 		});
	// 	},
	// 	[navigate],
	// );

	// const toolbar = (
	// 	<>
	// 		<div className="relative">
	// 			<Input
	// 				value={globalFilter}
	// 				onChange={(e) => {
	// 					setGlobalFilter(e.target.value);
	// 				}}
	// 				placeholder="Search Jingles..."
	// 				className="pl-10"
	// 			/>
	// 			<div className="pointer-events-none absolute left-2 top-0 h-full flex items-center justify-center">
	// 				<IconSearch className="h-4" />
	// 			</div>
	// 		</div>
	// 	</>
	// );

	// return (
	// 	<div className="flex flex-1 flex-col">
	// 		<div className="@container/main flex flex-1 flex-col gap-2">
	// 			<div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
	// 				<DataTableGeneric
	// 					columns={columns}
	// 					data={data ?? []}
	// 					isFetching={isFetching}
	// 					handleReload={() => refetch()}
	// 					toolbar={toolbar}
	// 					searchParams={{
	// 						...search,
	// 						q: globalFilter,
	// 					}}
	// 					onNavigate={handleNavigate}
	// 					getRowId={(row) => row.ID.toString()}
	// 					config={{
	// 						defaultPageSize: 25,
	// 						pageSizeOptions: [25, 50, 100, 500],
	// 					}}
	// 				/>
	// 			</div>
	// 		</div>
	// 	</div>
	// );
}
